<script setup lang="ts">
import IconItem from '@/components/Icon/IconItem.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import TooltipItem from '@/components/Tooltip/TooltipItem.vue'
import TypographyItem from '@/components/Typography/TypographyItem.vue'
import { EColors } from '@/types/constants/ColorValues'
import { EPosition } from '@/types/constants/PositionValues'
import { type DeviceModel } from '@/types/models/DeviceModel'
import DeviceUnavailabilityTooltip from './DeviceUnavailabilityTooltip.vue'

type Props = {
    device: DeviceModel
}
defineProps<Props>()
</script>

<template>
    <TooltipItem
        v-if="device.unavailability_periods?.periods?.length"
        :position="EPosition.RIGHT"
        class="unavailabity-tooltip fit-content">
        <StackLayout :gap="4" class="align-items-center incoming-rentals">
            <IconItem icon="triangle-exclamation" :type="EColors.WARNING" />
            <TypographyItem :label="$t('device.rental.incomingRentals')" />
        </StackLayout>
        <template v-if="device?.unavailability_periods?.periods" #content>
            <DeviceUnavailabilityTooltip :periods="device?.unavailability_periods?.periods" />
        </template>
    </TooltipItem>
</template>

<style scoped lang="scss">
.unavailabity-tooltip {
    z-index: 10;
}

.incoming-rentals {
    padding: 2px;
    padding-right: 8px;
    border: 1px solid $primary;
    border-radius: 8px;
}
</style>
